import prozesskontrollkarte from './prozesskontrollkarte';

export default {
  prozesskontrollkarte,
};
